import React from "react";
import { useI18n } from "../i18n/i18nService"; // Assurez-vous que i18n est correctement configuré

const NotFound = () => {
  const { t } = useI18n();

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">{t('404_not_found')}</h1>
      <p>{t('page_not_found')}</p>
    </div>
  );
};

export default NotFound;
